import React, { FunctionComponent, SVGProps } from 'react';

import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

interface CompletedIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  noAnimation?: boolean;
  gray?: boolean;
  size?: number;
}

const CompletedIcon: FunctionComponent<CompletedIconProps> = ({
  className,
  noAnimation,
  onClick,
  size,
  gray,
}) => {
  const path = {
    hidden: {
      pathLength: 0,
    },
    visible: {
      pathLength: 1,
      transition: {
        duration: 4,
        type: 'spring',
        stiffness: 50,
      },
    },
  };

  return (
    <motion.svg
      viewBox="0 0 24 24"
      width={size ? size : 24}
      height={size ? size : 24}
      className={className || ''}
      initial="hidden"
      animate="visible"
      onClick={onClick}
    >
      {gray ? (
        <CircleGray d="M12,0h0c6.63,0,12,5.37,12,12h0c0,6.63-5.37,12-12,12h0C5.37,24,0,18.63,0,12H0C0,5.37,5.37,0,12,0Z" />
      ) : (
        <Circle d="M12,0h0c6.63,0,12,5.37,12,12h0c0,6.63-5.37,12-12,12h0C5.37,24,0,18.63,0,12H0C0,5.37,5.37,0,12,0Z" />
      )}
      <Path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2px"
        d="M8,11.64l2.91,2.86,5.09-5"
        variants={noAnimation ? undefined : path}
      />
    </motion.svg>
  );
};

export default styled(CompletedIcon)`
  ${(props) =>
    props.onClick
      ? css`
          cursor: pointer;
        `
      : null}
  ${(props) =>
    props.size
      ? css`
          width: ${props.size}px;
          height: ${props.size}px;
        `
      : null}
`;

const Circle = styled.path`
  fill: ${({ theme }) => theme.colors.green};
`;

const CircleGray = styled.path`
  fill: ${({ theme }) => theme.colors.secondaryHover};
`;

const Path = styled(motion.path)`
  stroke: ${({ theme }) => theme.colors.white};
`;
